

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { WordFilter } from "@/utils/WordFilter";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { apiGetOssSign } from "../../service";
import { quillRedefine } from "vue-quill-editor-upload";
import { diyIcons } from "../../../config";
import { number } from "echarts";
@Component({
  components: {
    quillEditor,
  },
})
export default class CertificationInstructions extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public filterData;
  @Prop({ type: String, default: "" }) public value;
  @Prop({ type: String, default: "" }) public refEditor;
  @Prop({ type: String, default: "" }) public uploadFileImg;
  @Prop({ type: Number, default: 0 }) public index;
  public editorText = "";
  public quill: any = "";
  public isReset = false;
  public visible = false;
  public uploadInfo = "";
  public dir = "";
  public url = "";
  public imgData: any = {
    token: this.$fn.cookies.getToken("token"),
  };

  public editorOption = {
    /*  modules: {
      toolbar: [
        ["bold", "italic", "underline"], // 加粗 斜体 下划线
        ["image"],
        // [{ size: fontSizeStyle.whitelist }], // 字体大小
        // [{ color: [] }], // 字体颜色
      ],
    }, */
  };
  @Watch("value")
  public valueChange() {
    this.editorText = this.value;
  }
  public mounted() {
    WordFilter.instance().init(this.filterData);
    this.editorText = this.$fn.filter(this.value);
    this.quill = (this as any).$refs[this.refEditor].quill;
    this.initEvent();
  }
  public initEvent() {
    this.quill.on("text-change", (delta, oldDelta, source) => {
      this.$emit("input", this.$fn.filter(this.editorText));
    });
  }
  public created() {
    this.infoQuillEditor();
  }
  public onEditorBlur(e) {
    // 失去焦点事件
    this.$emit("blur", e);
  }
  public onEditorFocus(e) {
    // 获得焦点事件
    this.$emit("focus", e);
  }
  public onEditorChange(e) {
    // 内容改变事件
    this.$emit("change", this.editorText);
  }
  public handleFormatErrorImg(file) {
    this.$Message.error("图片" + file.name + "上传失败");
  }
  public async handleBeforeUploadImg(file) {
    this.isReset = false;
    if (file.size > 5242880)
      return this.$Message.info("单张大小最大5M，请重新上传");
    this.visible = true;
    this.uploadInfo = "图片上传中，请稍等";
    const res = await apiGetOssSign({
      dirName: "rule",
    });
    this.url = res.data.host;
    (this.imgData.token = this.$fn.cookies.getToken("token")),
      (this.imgData.policy = res.data.policy);
    this.imgData.OSSAccessKeyId = res.data.accessid;
    this.imgData.success_action_status = "200";
    this.imgData.signature = res.data.signature;
    this.imgData.name = file.name;
    this.dir = res.data.dir;
    const suffix = this.getSuffix(file.name);
    const chars = Date.parse(String(new Date()));
    const wenjian = chars + "_" + this.randomString(5) + suffix;
    this.imgData.key = res.data.dir + wenjian;
    const promise = new Promise((resolve) => {
      this.$nextTick(() => {
        resolve("");
      });
    });
    return promise;
  }

  public getSuffix(filename) {
    const pos = filename.lastIndexOf(".");
    let suffix = "";
    if (pos !== -1) {
      suffix = filename.substring(pos);
    }
    return suffix;
  }
  public randomString(len = 32) {
    const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    const maxPos = chars.length;
    let pwd = "";
    for (let i = 0; i < len; i += 1) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }
  // 初始化富文本编辑器
  public infoQuillEditor() {
    this.editorOption = quillRedefine({
      placeholder: "请输入正文(限制在10000字以内)", // 可选参数 富文本框内的提示语
      theme: "", // 可选参数 富文本编辑器的风格
      clipboard: {
        // 粘贴版，处理粘贴时候带图片
        matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]],
      },
      toolOptions: [
        [{ "upload-img": "IMGODY" }, "bold", "italic", "underline"], // 图片 视频 游戏 链接 1级标题 加粗 无序列表
      ],
      handlers: {
        // 图片
        "upload-img": () => {
          // 劫持原来的图片点击按钮事件
          const uploadFileImg: any = document.getElementById(
            this.uploadFileImg
          );
          uploadFileImg.click();
        },
      },
    });
  }
  public handleCustomMatcher(node, Delta) {
    const ops: any = [];
    Delta.ops.forEach((op) => {
      if (op.insert && typeof op.insert === "string") {
        // 如果粘贴了图片，这里会是一个对象，所以可以这样处理
        ops.push({
          insert: op.insert,
        });
      }
    });
    Delta.ops = ops;
    return Delta;
  }
  // 自定义图标
  public ready() {
    const TP = document.getElementsByClassName("ql-upload-img")[this.index];
    TP.innerHTML = diyIcons.tp;
  }
  // 插入图片
  public handleSuccessImg() {
    if (this.isReset) return false;
    const imgUrl = `${this.url}/${this.imgData.key}`;
    this.insertEle(imgUrl, "image");
  }
  public insertEle(url, type) {
    const quill = (this.$refs[this.refEditor] as any).quill;
    const length = quill.getSelection().index;
    // 插入视频  url为服务器返回的地址
    quill.insertEmbed(length, type, url);
    // 调整光标到最后
    quill.setSelection(length + 1);
    this.visible = false;
  }
}
